import React from 'react';
import UnitsPage from './UnitsPage';
import { connect } from 'react-redux';
import unitsActions from '../../../../actions/units.actions';
import helper from '../../../../utils/helper';

class Units extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      units: [],
      loading: false,
      errors: '',
    };
    this.columns = [
      { dataField: 'units', text: 'Units' },
      { dataField: 'scale', text: 'Scale', sort: true },
      { dataField: 'offset', text: 'Offset', sort: true },
      { dataField: 'description', text: 'Description', sort: true },
    ];
    this.defaultSorted = [
      {
        dataField: 'units',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit unit',
          action: (row, rowIndex) => {
            this.props.history.push(`/configure/units/edit-unit/${row.id}`);
          },
        },
        {
          name: 'Delete unit',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.units.units !== prevState.units) {
      state.units = nextProps.units.units;
    }
    if (nextProps.units.loading !== prevState.loading) {
      state.loading = nextProps.units.loading;
    }
    state.errors = helper.centralizeError([nextProps.units.errors]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    await this.props.getUnits();
  }
  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteUnit = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false, loading: true },
      async () =>
        await this.props
          .deleteUnit(selectedRow.id)
          .then(async () => await this.props.getUnits()),
    );
  };
  render() {
    return (
      <UnitsPage
        {...this.state}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeleteUnit={this.onDeleteUnit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    units: state.units,
  };
}

export default connect(mapStateToProps, unitsActions)(Units);
